function toCsv(errors) {
  const header = "row,reason";
  const body = (errors || []).map((item) => `${item.row || ""},"${String(item.reason || "").replace(/"/g, "\"\"")}"`);
  return [header, ...body].join("\n");
}

function downloadErrorsCsv(errors) {
  const blob = new Blob([toCsv(errors)], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = `klanten-import-fouten-${new Date().toISOString().slice(0, 10)}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export default function CustomerImportResultSummary({ result, onBackToList, onViewClients }) {
  if (!result) return null;

  const summary = result.summary || {};
  const errors = Array.isArray(result.errors) ? result.errors : [];
  const createdClients = Array.isArray(result.createdClients) ? result.createdClients : [];

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="text-base font-semibold text-slate-900">Importresultaat</h3>

      <div className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-4">
        <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-3">
          <p className="text-xs uppercase text-emerald-700">Succesvol</p>
          <p className="text-lg font-semibold text-emerald-800">{Number(summary.created || 0) + Number(summary.updated || 0)}</p>
        </div>
        <div className="rounded-lg border border-amber-200 bg-amber-50 p-3">
          <p className="text-xs uppercase text-amber-700">Overgeslagen</p>
          <p className="text-lg font-semibold text-amber-800">{summary.skipped || 0}</p>
        </div>
        <div className="rounded-lg border border-rose-200 bg-rose-50 p-3">
          <p className="text-xs uppercase text-rose-700">Fouten</p>
          <p className="text-lg font-semibold text-rose-800">{summary.failed || 0}</p>
        </div>
        <div className="rounded-lg border border-slate-200 bg-slate-50 p-3">
          <p className="text-xs uppercase text-slate-700">Totaal</p>
          <p className="text-lg font-semibold text-slate-900">{summary.totalRows || 0}</p>
        </div>
      </div>

      <div className="mt-4 flex flex-wrap gap-2">
        <button
          type="button"
          onClick={onBackToList}
          className="rounded-lg border border-slate-200 px-3 py-2 text-sm text-slate-700"
        >
          Terug naar klantenlijst
        </button>
        <button
          type="button"
          onClick={onViewClients}
          className="rounded-lg bg-slate-900 px-3 py-2 text-sm text-white"
        >
          Geimporteerde klanten bekijken
        </button>
        {errors.length > 0 && (
          <button
            type="button"
            onClick={() => downloadErrorsCsv(errors)}
            className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700"
          >
            Foutlijst downloaden
          </button>
        )}
      </div>

      {result.importBatchId && (
        <p className="mt-3 text-xs text-slate-500">Batch ID: {result.importBatchId}</p>
      )}

      {createdClients.length > 0 && (
        <div className="mt-3 rounded-lg border border-slate-200 bg-slate-50 p-3 text-xs text-slate-700">
          <p className="mb-1 font-semibold text-slate-800">Aangemaakte klanten (eerste 10)</p>
          <ul className="list-disc pl-4">
            {createdClients.slice(0, 10).map((item) => (
              <li key={item.id || item.naam}>{item.naam || item.id}</li>
            ))}
          </ul>
        </div>
      )}

      {errors.length > 0 && (
        <div className="mt-3 rounded-lg border border-rose-200 bg-rose-50 p-3 text-xs text-rose-800">
          <p className="mb-1 font-semibold">Foutregels (eerste 10)</p>
          <ul className="list-disc pl-4">
            {errors.slice(0, 10).map((item, index) => (
              <li key={`${item.row}-${index}`}>Rij {item.row}: {item.reason}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
